"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraceId = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.TraceId = typebox_1.Type.Optional(typebox_1.Type.String({
    title: 'Trace Id',
    description: 'Id of the trace associated with the message.',
}));
